// extracted by mini-css-extract-plugin
export default {"round-button":"RoundButton_round-button__NIRJA"};